import { atom } from 'jotai';

export const customThemeState = atom<{cssVariables: string; logo: string}>({
    cssVariables: '',
    logo: ''
});